import { Chip } from "@mui/material";
import { setFontColorBasedOnBackground } from "../Utils/Utils";

interface StatusChipProps {
  status?: {
    name?: string;
    color?: string;
    _id?: string;
  } | string;
}

export const StatusChip = ({ status }: StatusChipProps) => {
  if (!status) {
    return null;
  }

  const statusObj = typeof status === "string" ? { name: status } : status;
  const { name, color } = statusObj;

  if (!name) {
    return null;
  }

  return (
    <Chip
      label={name}
      size="small"
      style={{
        padding: 5,
        margin: 5,
        backgroundColor: color || "#e0e0e0",
        color: color ? setFontColorBasedOnBackground(color) : "#000",
      }}
    />
  );
};
